export const isFullUrl = (url: string | undefined): boolean => {
  if (!url) return false

  const urlPattern = /^(?:\w+:)?\/\/(\S+)$/

  return urlPattern.test(url)
}
